import { Injectable } from '@angular/core';
import {ResourcesService} from '../resources.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class IventoryService {

  constructor(private _resourcesService: ResourcesService) { }

  getAnonymProductDetailById(supplierId: number | string, productId: number | string): Observable<any> {
    return this._resourcesService.get('inventory/GetAnonymProductDetailById?supplierId=' + supplierId + '&productId=' + productId, false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/iventory/iventory.service.ts